import VuexPersistence from "vuex-persist";
export default new VuexPersistence({
  //process.env.VUE_APP_NAME
  key: process.env.VUE_APP_NAME,
  storage: window.localStorage,
  modules: ["auth"], //general
});